<app-service-detail>
    <div class="row w-100 m-0 position-relative ">
        <app-variables-tabs class="container-fluid px-5"></app-variables-tabs>
        <app-list-links 
            class="col-md-12 px-md-5 ml-auto"
            [items]="items" 
            [showSearch]=true
            headingText="Tables available in the service">
        </app-list-links>
    </div>
</app-service-detail>
